import React from 'react'

const HelpDaraz = () => {
  return (
    <>
      <h2>How to get Daraz API Key for PixelOne</h2>
      <h4>Login into your Daraz store with Admin Access:</h4>
      <p>
        Each API call is performed by a specific Seller Center user (specified
        by the UserID parameter and signed by a matching API key). Take the
        following steps to retrieve your API key.
      </p>
      <strong>Step 1: Register as a seller on Daraz at:</strong>
      <p>
        For the live environment:
        https://sellercenter.daraz.xx/seller/register/registration_open (xx
        represents the country domain name)
      </p>
      <p>
        For the staging environment:
        https://sellercenter-staging.daraz.xx/seller/register/registration_open
      </p>
      <strong>Step 2: Log in the Seller Center at:</strong>
      <p>
        For the live environment: https://sellercenter.daraz.xx/(xx represents
        the country domain name)
      </p>
      <p>For the staging environment: https://sellercenter-staging.daraz.xx/</p>
      <strong>Step 3: Click Settings -{'>'} User Management.</strong>
      <p>Add or remove users under the seller account.</p>
      <p>
        Specify the role of a user to define API groups that the user can call.
        Ask your vendor manager/key account manager for the API key. Each user
        will have a unique API key when calling an API.
      </p>
    </>
  )
}

export default HelpDaraz
